import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { featureFlagReducer } from '@surfline/web-common';
import animations from './animations';
import editorial from './editorial';
import editorialTaxonomyDetails from './editorialTaxonomyDetails';
import editorialTaxonomyPosts from './editorialTaxonomyPosts';
import forecast from './forecast';
import status from './status';
import user from './user';
import locationView from './locationView';
import swellEvents from './swellEvents';
import topSpots from './topSpots';
import worldTaxonomy from './worldTaxonomy';

export default (history) =>
  combineReducers({
    router: connectRouter(history),
    animations,
    editorial,
    forecast,
    status,
    user,
    locationView,
    swellEvents,
    topSpots,
    worldTaxonomy,
    editorialTaxonomyDetails,
    editorialTaxonomyPosts,
    flags: featureFlagReducer,
  });
